export default "__VITE_ASSET__C8ULff94__"